/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Profiles Creation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './profilesCreationView';

export const mapStateToPropsProfileCreation = mapStateToProps;
export const mapDispatchToPropsProfileCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsProfileCreation,
  mapDispatchToPropsProfileCreation
)(View);
